export default function formatUrlTitle(string) {
  const url = string.trim().replaceAll("[^A-Za-z0-9]", "");
  return url.toLowerCase().replaceAll(" ", "-");
}